var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('button',{staticClass:"nav-link btn btn-link",on:{"click":_vm.submit}},[_c('span',[_vm._v("Update")]),_vm._v(" "),(_vm.loading)?_c('fa',{attrs:{"icon":"circle-notch spinner"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }